export enum LinkType {
    Deeplink = "Deeplink",
    LeadCapture = "LeadCapture",
    Subscription = "Subscription",
}